import angular from 'angular';

module.exports = angular.module('common.directives.percent-int', [])
.directive('type', function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function link(scope, element, attrs, ngModel) {
      if (attrs.type !== 'percent-int' || !ngModel) return;

      // String Percent -> Int Percent
      ngModel.$parsers.push(function(value) {
        if (!value) return null;

        return parseInt(value);
      });

      // Int Percent -> String Percent
      ngModel.$formatters.push(function(value) {
        if (!value && value !== 0) return null;
        return value + '%';
      });
    },
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/percent-int.js
 **/